<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-04-28 18:06:25
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\BlockLeave\BlockLeavePolicy\components\newMapping.vue
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-05 11:00:43
-->
<template>
  <normalDialog
    :title="$t('label_essweb_BlockLeavePolicy_form_property_dialog_title')"
    :dialog="show"
    @close="show = false"
    maxWidth="400"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start" class="white lighten-5">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              class="flex-grow-1"
              isRequired
              two-line
              :items="LeaveTypeList"
              item-text="leave_type_name"
              label="label_essweb_leaveType_list_title"
              item-value="uuid"
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              v-model="leave_type_uuid"
            >
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.leave_type_name) }}
                <span class="text--secondary text-caption"
                  >({{ $getCommonLangValue(data.item.leave_type_abbr) }})</span
                >
              </template>
              <template v-slot:item.title="{ data }">
                {{ $getCommonLangValue(data.item.leave_type_name) }}
              </template>
              <template v-slot:item.subtitle="{ data }">
                {{ $getCommonLangValue(data.item.leave_type_abbr) }}
              </template>
            </AutoComplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="show = false" />
    </template>
  </normalDialog>
</template>
<script>
export default {
  name: "newMapping",
  data() {
    return {
      show: false,
      LeaveTypeList: [],
      leave_type_uuid: "",
      uuid: "",
    };
  },
  created() {
    this.getLeaveType();
  },
  methods: {
    getLeaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",
      }).then((res) => {
        that.LeaveTypeList = res.data;
      });
    },
    new(uuid) {
      this.leave_type_uuid = "";
      if (this.$refs["form"]) this.$refs["form"].reset();
      this.uuid = uuid;
      this.show = true;
    },
    toSave() {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group_map_leave_type",
        url: "/block-leave-group-map/add/",
        data: {
          block_leave_group_uuid: this.uuid,
          leave_type_uuid: this.leave_type_uuid,
        },
      }).then((res) => {
        that.show = false;
        that.$emit("change");
      });
    },
  },
};
</script>